import AbstractChroniqueSection from "./AbstractChroniqueSection";
import { List } from "immutable";
import ImageRecord from "./ImageRecord";
/**
 * ChroniqueSection with 1 landscape image
 */
export class ChroniqueSectionLandscape1 extends AbstractChroniqueSection() {
  /**
   * @return {ImageRecord}
   */
  image() {
    return this._getOne("Layout", ImageRecord);
  }

  /**
   * Helper to keep consistent with other childs type.
   * @return {List<ImageRecord>}
   */
  images() {
    return new List([this.image()]);
  }
}

/**
 * ChroniqueSection with 2 square images
 */
export class ChroniqueSectionSquare2 extends AbstractChroniqueSection() {
  /**
   * @return {List<ImageRecord>} Maximum of 2 image square
   */
  images() {
    return this._getMany("Layout", (i) => new ImageRecord(i));
  }
}

/**
 * Chroniqque with 2 portraits images
 */
export class ChroniqueSectionPortrait2 extends AbstractChroniqueSection() {
  /**
   * @return {List<ImageRecord>} Maximum of 2 image square
   */
  images() {
    return this._getMany("Layout", (i) => new ImageRecord(i));
  }
}



// WEBPACK FOOTER //
// ./src/models/ChroniqueSection.js